export interface IVariableParams {
  variableName: string;
  variableValue: string | number | boolean;
}

export interface IQueryParam {
  paramName: string;
  paramValue: string | number | boolean;
}

export interface ICommonAPIresponse {
  data: any;
  errors: string;
  message: string;
  messagekeys: any;
  result: boolean;
  statusCode: number;
  warnings: string;
}

export const BASE_URL = process.env.REACT_APP_API_URL || "";

export const getUrl = (
  serviceUrl: string,
  variables?: IVariableParams[],
  params?: IQueryParam[]
) => {
  const variablesKeyValuePairs: { [key: string]: string | number | boolean } =
    {};

  variables?.forEach((item) => {
    variablesKeyValuePairs[item.variableName] = item.variableValue;
  });

  serviceUrl = serviceUrl.replace(/\{(\w+)\}/g, (match, name) => {
    return variablesKeyValuePairs[name].toString();
  });

  let url = `${serviceUrl.startsWith("http") ? "" : BASE_URL}${serviceUrl}`;
  if (params && params.length > 0) {
    const queryParams = new URLSearchParams();
    params.forEach((param) => {
      queryParams.set(param.paramName, param.paramValue.toString());
    });
    url += `?${queryParams.toString()}`;
  }
  return url;
};

export const handleResponse = async (
  response?: any,
  ignoreResponse?: boolean
) => {
  let error: any = null;
  let result: any = {};

  if (response.ok || (response.status !== 500 && response.status !== 400)) {
    if (response.status === 204) {
      result = {
        errors: null,
        messages: [
          {
            Message: "Updated successfully.\r\n",
            Code: "",
          },
        ],
        result: true,
        warnings: null,
      };
    } else {
      result = !ignoreResponse ? await response.json() : null;
    }

    if (result && typeof result === "object") {
      result.statusCode = response.status;
    }
  } else {
    error = await handleError(response);
  }

  return { result, error };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleError = async (response: any) => {
  let error;
  if (response.error) {
    error = { message: response.error };
  } else {
    try {
      error = await response.json();
    } catch (e) {
      error = null;
    }
  }

  return {
    ...error,
    message: error,
    statusCode: response.status,
  } as ICommonAPIresponse;
};
